module.exports = __webpack_public_path__ + "static/media/Character-02.63f955b7.png";